import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import React from "react";
import { SVGAsset } from "res";

/**
 * @function TASPositivePayImportChecksTemplateListTableRow
 * @return {React.Component}
 * @exported true
 * @description This is the table row for NonNachaTemplateListTable
 */
export default function TASPositivePayImportChecksTemplateListTableRow(props) {
    const templateName = props.templateName ?? "[[Template Name]]"
    const transactionType = props.transactionType ?? "";

    return (
        <TableItemContainer>
            <TableItemTextView className="template-name-col" text={
                <DisabledPrompt>
                    <a className="clickable">{ templateName }</a>
                </DisabledPrompt>
            } />
            <TableItemTextView className="transaction-type-col" text={transactionType} />
            <TableItemView className="edit-col">
                <DisabledPrompt>
                    <SVGAsset id="EditIcon" className="clickable" />
                </DisabledPrompt>
            </TableItemView>
            <TableItemView className="delete-col">
                <DisabledPrompt>
                    <SVGAsset id="TrashcanXIcon" className="clickable" />
                </DisabledPrompt>
            </TableItemView>
        </TableItemContainer>
    )
}